import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class FontsizeService {
  private _userFontSize = new Subject();
  userFontSize$ = this._userFontSize.asObservable();
  constructor() {}

  getFontSize() {}

  setFontSize(value) {
    if (value < 16) return;
    if (value > 24) return;
    document.getElementsByTagName('html')[0].style.fontSize = `${value}px`;
    document.cookie = `fontSize=${value}`;
    // this._userFontSize.next(`fs-${value}` || 16)
  }
}
